import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import footer_icon1 from '../../img/footer_icon1.svg';
import footer_icon2 from '../../img/footer_icon2.svg';
import footer_icon3 from '../../img/footer_icon3.svg';
import footer_icon4 from '../../img/footer_icon4.svg';
import footer_icon5 from '../../img/footer_icon5.svg';

import Big3Common from "../../js/Big3Common";
/**
 * 개발담당:양유빈
 * 화면기능:공통 풋터 화면
 **/
export class Footer extends Component {
    static displayName = Footer.name;

    constructor(props) {
        super(props);
        this.state = {
            Conf_Count: 0,
            Jm_Count: 0,
            Wa_Count:0,
            fillName:""
        };
        Big3Common.Authentication(this);
    }
    //초기화
    componentDidMount() {
        this.CallGetFooterCount();
        if (this.props.fillName !== null) {
            this.setState({ fillName: this.props.fillName });
        }
    }
    CallGetFooterCount = async () => {
       
        try {
            let Data = await Big3Common.Get(`api/Common/Common/GetFooterCount`);
            const fillName = this.props.fillName !== null ? this.props.fillName : "";
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                if (DataList.length > 0) {
                    this.setState({
                        Conf_Count: DataList[0]["conf_count"],
                        Jm_Count: DataList[0]["jm_count"],
                        Wa_Count: DataList[0]["wa_count"],
                        fillName: fillName
                    })
                }
                else {
                    this.setState({
                        fillName: fillName
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallGetFooterCount: ", e)
        }
    }
    render() {
        return (
            <footer>
                <ul>
                    <li>
                        <div className="footer_icon">
                            <Link to="/Retail/MyRetail/Index">
                                <img src={footer_icon1} alt="거래처관리" className={this.state.fillName === "icon1" ? "fill" : ""} />
                                {this.state.Wa_Count === 0 ? "" : <p className="f_new"></p>}
                            </Link>
                            <div className="footer_txt">내 거래처</div>
                        </div>
                    </li> 
                    <li>
                        <div className="footer_icon">
                            <Link to="/Order/OrderMgr/Index">
                                <img src={footer_icon2} alt="주문관리" className={this.state.fillName === "icon2" ? "fill" : ""} />
                                {this.state.Jm_Count === 0 ? "" : <p className="f_new"></p>}
                            </Link>
                            <div className="footer_txt">주문목록</div>
                        </div>
                    </li>
                    <li>
                    <div className="footer_icon">
                            <Link to="/">
                                <img src={footer_icon3} alt="홈" className={this.state.fillName === "icon3" ? "fill" : ""} />
                            </Link>
                            <div className="footer_txt">홈</div>
                        </div>
                    </li> 
                    <li>
                        <div className="footer_icon">
                            <Link to="/Order/QuestionMgr/Index">
                                <img src={footer_icon4} alt="주문문의" className={this.state.fillName === "icon4" ? "fill" : ""} />
                                {this.state.Conf_Count === 0 ? "" : <p className="f_new"></p>}
                            </Link>
                            <div className="footer_txt">문의하기</div>
                        </div>
                    </li>
                    <li>
                        <div className="footer_icon">
                            <Link to="/MyPage/MyInfoMgr/Index"><img src={footer_icon5} alt="마이페이지" className={this.state.fillName === "icon5" ? "fill" : ""} />
                            </Link>
                            <div className="footer_txt">마이페이지</div>
                        </div>
                    </li>
                </ul>
            </footer>
        );
    }
}

